// const WIN_IMG = 'https://s3-ap-southeast-1.amazonaws.com/caas-media-storage/upload/photos/LINE_Game_Default_Image/common/prize_result_win.png'
const WIN_IMG = 'https://dummyimage.com/350x350/000/fff'
const NO_PRIZE_IMG = 'https://s3-ap-southeast-1.amazonaws.com/caas-media-storage/upload/photos/LINE_Game_Default_Image/common/prize_result_notwin.png'

const basePrizes = [
  { id: 1, name: '一等獎 - 精美禮品', image: WIN_IMG, probability: 20 },
  { id: 2, name: '二等獎 - 優惠券', image: WIN_IMG, probability: 20 },
  { id: 3, name: '三等獎 - 貼圖包', image: WIN_IMG, probability: 20 },
  { id: 4, name: '三等獎 - 貼圖包', image: WIN_IMG, probability: 20 },
  { id: 5, name: '銘謝惠顧', image: NO_PRIZE_IMG, probability: 20 },
]

const winwheelColors = ['#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF']
const winwheelPrizes = basePrizes.map((prize, index) => ({
  ...prize,
  bgColor: winwheelColors[index % winwheelColors.length],
  textColor: '#fff',
}))

const baseGame = {
  remainingDraws: 10,
  enableShare: true,
  enablePrize: true,
  shareText: '快來玩遊戲！http://localhost:8080',
  winTitle: '恭喜獲獎！',
  winSubtitle: '您已成功獲得以下獎品',
  noPrizeTitle: '很遺憾，未中獎',
  noPrizeSubtitle: '下次再試試看！',
  startButtonImage: '',
  bgImage: '',
  status: 1,
  prizes: basePrizes,
  rule: "1. Each company is limited to one promo code, which is valid for two months from the date of issuance.\n2. New Customers: Must complete the contract signing within two months to be eligible for free AI credits. \n3. Existing Customers: Please present this coupon to your dedicated Customer Success Manager to redeem the AI credits.\n4. All rewards are non-transferable and cannot be exchanged for cash or other products.\n5. All activity data and records shall be based on Omnichat's internal system.\n6. Omnichat reserves the right of final decision in the event of any dispute.",
}

export const mockGames = {
  capsule: {
    ...baseGame,
    id: 'mock-capsule-001',
    name: '扭蛋機 (Mock)',
    type: 2,
    bgColor: '#9C84FF',
    mainColor: '#7A5AF8',
    prizeImage: 'https://dummyimage.com/350x350/000/fff',
  },
  slot: {
    ...baseGame,
    id: 'mock-slot-001',
    name: '拉霸機 (Mock)',
    type: 1,
    bgColor: '#FFC670',
    reelImages: [WIN_IMG, NO_PRIZE_IMG, WIN_IMG],
  },
  chouqian: {
    ...baseGame,
    id: 'mock-chouqian-001',
    name: '抽籤 (Mock)',
    type: 3,
    bgColor: '#FFD98F',
  },
  scratch: {
    ...baseGame,
    id: 'mock-scratch-001',
    name: '刮刮卡 (Mock)',
    type: 4,
    bgColor: '#7277FF',
    mainImage: '',
    secondaryImage: '',
  },
  winwheel: {
    ...baseGame,
    id: 'mock-winwheel-001',
    name: '幸運輪盤 (Mock)',
    type: 5,
    bgColor: '#C184FF',
    mainColor: '#C184FF',
    prizes: winwheelPrizes,
    secondaryImage: '',
  },
}

export const MOCK_USER_ID = 'mock-user-dev-001'
export const MOCK_GAME_ID = 'mock-game-dev-001'

export function buildMockStartResult(gameData, forceNoPrize = false) {
  const noPrizeItem = gameData.prizes[gameData.prizes.length - 1]
  const prizes = gameData.prizes.filter(p => p.id !== noPrizeItem.id)
  const noPrize = forceNoPrize || Math.random() < 0.3
  if (noPrize) {
    return { prizeId: noPrizeItem.id, prizeName: '', prizeImage: '', prizeRecordId: `mock-record-${Date.now()}`, noPrize: true }
  }
  const prize = prizes[Math.floor(Math.random() * prizes.length)]
  return {
    prizeId: prize.id,
    prizeName: prize.name,
    prizeImage: prize.image,
    prizeRecordId: `mock-record-${Date.now()}`,
    noPrize: false,
  }
}
